import { ModalDismiss } from '@apps-common/config/modal'
import { invalidateScheduleQueries } from '@apps-common/lib/invalidateScheduleQueries'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { useIonModal } from '@ionic/react'
import { IScheduleModifyModalProps, ScheduleModifyModal } from '../modals/schedule-modify-modal/ScheduleModifyModal'

export const useScheduleModifyModal = ({ status, unitId, productId, scheduleId }: IScheduleModifyModalProps) => {
  const [present, dismiss] = useIonModal(ScheduleModifyModal, {
    componentProps: {
      status,
      unitId,
      productId,
      scheduleId
    },
    onDismiss: (data: string, role: string) => {
      if (role === ModalDismiss.Confirm) {
        invalidateScheduleQueries(scheduleId, unitId)
      }
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return {
    present: () => {
      present({
        enterAnimation: modalSlideUpEnterAnimation,
        leaveAnimation: modalSlideUpLeaveAnimation,
        backdropDismiss: true
      })
    },
    dismiss
  }
}
